var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-800",attrs:{"id":"app"}},[_c('UserBar'),_vm._v(" "),_c('ExportModal'),_vm._v(" "),_c('ImportModal'),_vm._v(" "),_c('DataModal'),_vm._v(" "),_c('HelpModal'),_vm._v(" "),_c('StatisticsModal'),_vm._v(" "),_c('EndlessModal'),_vm._v(" "),_c('EndlessNameModal'),_vm._v(" "),_c('EndlessUpdateNameModal'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-040374bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 